import React from 'react';

const rupee = (n) => `₹${Math.round(n).toLocaleString('en-IN')}`;

const Pending = () => <span className="csr-chip csr-chip--amber">Pending data</span>;

/** "Soil health & income" cards. Values come from CSR_IMPACT_PLACEHOLDERS until real data exists. */
const ImpactSignalCards = ({ impact }) => {
  const { soilScore, income, fertilizerReductionPct, ipmPct } = impact;
  const scoreGain = soilScore.after - soilScore.before;

  return (
    <section aria-labelledby="csr-sig-h" className="d-flex flex-column" style={{ gap: 10 }}>
      <h2 id="csr-sig-h" className="csr-section-title"><span className="csr-dot" />Soil health &amp; income</h2>
      <div className="csr-signals">
        <div className="csr-card csr-signal">
          <div className="csr-signal__head"><span>Soil · 16 parameters</span><Pending /></div>
          <div className="csr-signal__pair">
            <span className="csr-signal__big csr-signal__big--before">{soilScore.before}</span>
            <span className="csr-signal__arrow">→</span>
            <span className="csr-signal__big">{soilScore.after}</span>
            <span className="csr-signal__unit">avg soil health score / 100</span>
          </div>
          <span className="csr-signal__note">{`${scoreGain >= 0 ? '+' : ''}${scoreGain} points between first test and retest.`}</span>
        </div>

        <div className="csr-card csr-signal">
          <div className="csr-signal__head"><span>Net farm income per acre</span><Pending /></div>
          <div className="csr-signal__pair">
            <span className="csr-signal__mid csr-signal__mid--before">{rupee(income.before)}</span>
            <span className="csr-signal__arrow">→</span>
            <span className="csr-signal__mid">{rupee(income.after)}</span>
          </div>
          <span className="csr-signal__note">Before vs after joining, after input costs</span>
          <span className="csr-signal__delta">{`+${rupee(income.delta)} per acre (+${income.pct.toFixed(1)}%)`}</span>
        </div>

        <div className="csr-card csr-signal">
          <div className="csr-signal__head"><span>Chemical fertilizer use</span><Pending /></div>
          <span className="csr-signal__big">{`−${fertilizerReductionPct}%`}</span>
          <span className="csr-signal__note">Urea &amp; DAP, among followed-up farmers, using soil-based dosing</span>
        </div>

        <div className="csr-card csr-signal">
          <div className="csr-signal__head"><span>Farmers using IPM</span><Pending /></div>
          <span className="csr-signal__big">{`${ipmPct}%`}</span>
          <span className="csr-signal__note">Adopted integrated pest management after advice</span>
        </div>
      </div>
    </section>
  );
};

export default ImpactSignalCards;